import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Country, Movie } from '@usheru-hff/shared/domain';
import { EMAIL_PATTERN } from '@usheru-hff/shared/utils';
import { LocationService } from '@usheru-hff/sdk/location';
import { MovieService } from '@usheru-hff/sdk/movie';
/**
 * //TODO docs favio
 * //TODO barbeitoalex propostal - organice life cycle methods. Split in specific method to improve docs.
 * //TODO barbeitoalex propostal - move component folder to the root of components
 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes
 */
@Component({
  selector: 'ush-enquiries',
  templateUrl: './enquiries.component.html',
  styleUrls: ['./enquiries.component.scss']
})
export class EnquiriesComponent implements OnInit {
  countryList: Country[];
  rightAvailabilitiesCountries: Country[];

  countriesNoAvailable: string;

  form: FormGroup;
  submitIntent: boolean;
  submitted: boolean;
  onSubmitionError: boolean;

  processingSubmition: boolean;

  @Input() movie: Movie;

  constructor(
    private locationService: LocationService,
    private formBuilder: FormBuilder,
    private movieService: MovieService
  ) {
    this.form = this.formBuilder.group({
      name: new FormControl('', Validators.required),
      surname: new FormControl('', Validators.required),
      company: new FormControl('', Validators.required),
      companyRole: new FormControl(''),
      country: new FormControl(null, Validators.required),
      email: new FormControl('', [Validators.required, Validators.pattern(EMAIL_PATTERN)]),
      comments: new FormControl('')
    });
  }

  ngOnInit(): void {
    // fill the country list from collections
    this.countryList = this.locationService.getAvailableCountries();

    // // get right availabilities
    // this.movieService
    //   .getRightAvailabilities({ movie: this.movie.id })
    //   .subscribe(rAvailabilities => (this.rightAvailabilitiesCountries = this.getCountriesFromIds(rAvailabilities)));
  }

  onSubmit(): void {
    this.submitIntent = true;
    if (this.form.valid) {
      const interestObj = this.buildAvailabilityInterest();
      this.submitAvailabilityInterest(interestObj);

      //TODO Tracking
    }
  }

  submitAvailabilityInterest(interestObj: AvailabilityInterest) {
    this.processingSubmition = true;
    // TODO: remove fake api request
    // setTimeout(() => {
    //   this.processingSubmition = false;
    //   this.setFormSubmitted();
    // }, 2000);
    this.movieService.postAvailabilityInterest(interestObj).subscribe(
      () => {
        this.processingSubmition = false;
        this.setFormSubmitted();
      },
      err => {
        this.processingSubmition = false;
        this.onSubmitionError = true;
        console.error(err);
      }
    );
  }

  buildAvailabilityInterest(): AvailabilityInterest {
    const ctrls = this.form.controls;
    const avInterest: AvailabilityInterest = {
      movieId: this.movie.id,
      countries: ctrls.country.value.map(c => c.id).join(','),
      firstName: ctrls.name.value,
      surname: ctrls.surname.value,
      email: ctrls.email.value,
      companyName: ctrls.company.value
    };
    ctrls.companyRole.value && (avInterest.companyRole = ctrls.companyRole.value);
    ctrls.comments.value && (avInterest.message = ctrls.comments.value);

    return avInterest;
  }

  setFormSubmitted() {
    this.submitted = true;

    //TODO Tracking
  }

  // onCountriesSelectedChange() {
  //   let noAvailableCountries: Country[] = [];

  //   this.form.controls.country.value.forEach(country => {
  //     if (!this.rightAvailabilitiesCountries.some(c => c.id == country.id)) {
  //       noAvailableCountries.push(country);
  //     }
  //   });
  //   this.countriesNoAvailable = noAvailableCountries.map(c => c.name).join(', ');
  // }

  getCountriesFromIds(countryIds: unknown[]) {
    const countriesFound: Country[] = [];
    for (const id of countryIds) {
      countriesFound.push(this.countryList.find(c => c.id == id));
    }
    return countriesFound;
  }
}

interface AvailabilityInterest {
  countries: string;
  companyName: string;
  firstName: string;
  surname: string;
  email: string;
  message?: string;
  companyRole?: string;
  movieId: string;
}
